module.exports = __webpack_public_path__ + "static/auggie-2fc6e39c4527cde44a71f594b66752d9.svg";